import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const RELOAD_ON_CHUNK_ERROR_KEY = '__kiosk_chunk_reload_once__';

const getVersionUrl = () => {
  if (typeof window === 'undefined') return '/version.json';
  const isAdminPath = window.location.pathname.startsWith('/admin');
  return isAdminPath ? '/admin/version.json' : '/version.json';
};

const fetchVersion = async () => {
  const r = await fetch(getVersionUrl(), { cache: 'no-store' });
  if (!r.ok) throw new Error(`Version fetch failed: ${r.status}`);
  const j = await r.json();
  return String(j?.version || '').trim();
};

const startVersionWatcher = () => {
  let initialVersion = null;
  let stopped = false;

  const tick = async () => {
    if (stopped) return;
    try {
      const v = await fetchVersion();
      if (!v) return;
      if (!initialVersion) {
        initialVersion = v;
        return;
      }
      if (v !== initialVersion) {
        // Soft hint + automatic refresh when a new deploy is detected.
        console.log('[VersionWatcher] New version detected, reloading...', { from: initialVersion, to: v });
        window.location.reload();
      }
    } catch (_) {
      // ignore transient network/version endpoint failures
    }
  };

  tick();
  const id = window.setInterval(tick, 60000);
  return () => {
    stopped = true;
    window.clearInterval(id);
  };
};

const installChunkErrorReload = () => {
  const shouldReloadForError = (msg) => {
    const t = String(msg || '').toLowerCase();
    return t.includes('chunkloaderror') || t.includes('loading chunk') || t.includes('failed to fetch dynamically imported module');
  };

  const maybeReloadOnce = (reason) => {
    const already = sessionStorage.getItem(RELOAD_ON_CHUNK_ERROR_KEY) === '1';
    if (already) return;
    sessionStorage.setItem(RELOAD_ON_CHUNK_ERROR_KEY, '1');
    console.warn('[ChunkRecovery] Reloading after chunk load failure:', reason);
    window.location.reload();
  };

  window.addEventListener('error', (event) => {
    if (shouldReloadForError(event?.message) || shouldReloadForError(event?.error?.message)) {
      maybeReloadOnce(event?.message || event?.error?.message);
    }
  });

  window.addEventListener('unhandledrejection', (event) => {
    if (shouldReloadForError(event?.reason?.message || event?.reason)) {
      maybeReloadOnce(event?.reason?.message || event?.reason);
    }
  });
};

installChunkErrorReload();
startVersionWatcher();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);